import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { InternalCandidacyComment } from "@/types";

/**
 * This hook is used to update an internal candidacy comment in the internal
 * candidacy comments query without refetching the entire query.
 */
export const useSetInternalCandidacyCommentInInternalCandidacyComments = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    candidacyId,
    internalCandidacyCommentToUpdate,
  }: {
    candidacyId: string;
    internalCandidacyCommentToUpdate: InternalCandidacyComment;
  }) => {
    queryClient.setQueryData(
      [
        "internal-candidacy-comments",
        currentCompanyId,
        currentJobId,
        candidacyId,
      ],
      (cachedData: InternalCandidacyComment[]) => {
        return cachedData.map((internalCandidacyComment) => {
          if (
            internalCandidacyComment.id === internalCandidacyCommentToUpdate.id
          ) {
            return internalCandidacyCommentToUpdate;
          }
          return internalCandidacyComment;
        });
      },
    );
  };
};
